module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAR1JREFUKBWtkj9uwjAYxf05/BmSkaEDF2BmaBeqZo8Et2Bpb9BuvQEsnKFLkZKsadkYmLkARyCRkOq433PiyLUqJix98vN7P9vyHyG8luf5AuXZglyjKIqoLMsjvDAMJ3Ecn20urUBfVdW71nqMgnazbsU0TacM7DkMWkAR0X2SJAeMzYoMINxwWQiZ8dqsAbMse2FjitRt8JDBIz7hWCmFA0Qu5OhzEAQTWdf1+goEPmoZZ+4tJF2+Hz+F1vOrixFt5WAon0lQ9wL+BGRgJD18nYTUbz7QjTkDYy68P7tbEQnzAh3AAh4yeAYk+lBC9pa8jbKg0fCQWRBiMCsO/Jdwp01jbbx2+Of39EfylTc8oRptZ/3T/+yeFig/+gVrVmldZS3cHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_sort_down.png
// module id = 863
// module chunks = 125